import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AngularFireAuth } from "angularfire2/auth";
import { ViewController } from "ionic-angular";

import { AuthProvider } from "../../providers/auth/auth";

@Component({
  selector: "province-selector",
  templateUrl: "province-selector.html",
})
export class ProvinceSelectorComponent implements OnInit {
  uid: string;
  authSubscription: any;

  provinceForm: FormGroup;

  provinces: Array<string> = [
    "Eastern Cape",
    "Free State",
    "Gauteng",
    "KwaZulu-Natal",
    "Limpopo",
    "Mpumalanga",
    "Northern Cape",
    "North West",
    "Western Cape",
  ];

  constructor(
    public viewCtrl: ViewController,
    private authProvider: AuthProvider,
    private formBuilder: FormBuilder,
    private afAuth: AngularFireAuth
  ) {
    this.provinceForm = this.formBuilder.group({
      province: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    this.authSubscription = this.afAuth.authState.subscribe((fbUser) => {
      if (fbUser) {
        this.uid = fbUser.uid;

        console.log("uid inside province selector");
        console.log(this.uid);
      }
    });
  }

  submit() {
    console.log("inside submit");
    console.log(this.provinceForm.value);

    if (!this.provinceForm.valid) {
      console.log("form not valid");
    } else {
      this.authProvider
        .updateSatffUserProvince(this.uid, this.provinceForm.value.province)
        .then(() => {
          this.close();
        });
    }
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/shared/province-selector/province-selector.ts